import { GroupId } from 'types';

export const GROUPS = '/api/v1/groups';
export const GROUPS_EMPLOYEES = '/api/v1/groups/employees';
export const GROUP = (groupId: GroupId) => `/api/v1/groups/${groupId}`;
export const ARCHIVE_GROUP = (groupId: GroupId) => `/api/v1/groups/${groupId}/archive`;
